import { getFirestore } from '../../system/firebase';

// import { SNACK_BAR_MESSAGE_OPERATION_FAILED, SNACK_BAR_MESSAGE_SAVE } from '../constants';
import { mapCreatableLovOptionsToValueList, getNewLovOptions, isNewLovOption } from '../lovHelper';
import { convertFirebaseTimestampsToDate } from '../dateHelper';
import { deleteEmptyFields, mapProfileFromFirestore } from '../dtoHelper';

import _get from 'lodash/get';
import _set from 'lodash/set';
import _fpSet from 'lodash/fp/set';
import _map from 'lodash/map';
import _isEmpty from 'lodash/isEmpty';
import _isNaN from 'lodash/isNaN';
import _toNumber from 'lodash/toNumber';
import _toLower from 'lodash/toLower';
import _pick from 'lodash/pick';

//TODO Remove this function after Native app is refactored to use loadDashboardById
export const loadDashboardByUserId = (userId, setDashboardData) => {
    const db = getFirestore();

    // const dashboardsRef = db.collection('dashboards').where('jobSeekerId', '==', userId);
    const dashboardsRef = db.collection('dashboards').doc(userId);

    return dashboardsRef.onSnapshot(docSnapshot => {
        // expect only one document per user
        // const doc = _get(querySnapshot, 'docs[0]');
        let data = docSnapshot.data();
        data = convertFirebaseTimestampsToDate(data, ['showMakeProfilePublicTourStepDt']);
        setDashboardData(data);
    });
};

export const loadDashboardById = ({ docId, setData }) => {
    const db = getFirestore();

    const dashboardsRef = db.collection('dashboards').doc(docId);

    return dashboardsRef.onSnapshot(docSnapshot => {
        // expect only one document per user
        let data = docSnapshot.data();
        data = convertFirebaseTimestampsToDate(data, ['showMakeProfilePublicTourStepDt']);
        setData(data);
    });
};

export const loadProfileByUserId = (userId, setProfileData) => {
    const db = getFirestore();

    const profileRef = db.collection('profiles').doc(userId);

    return profileRef.onSnapshot(docSnapshot => {
        let data = docSnapshot.data();

        data = convertFirebaseTimestampsToDate(data, ['createDt', 'updateDt']);
        const resumeList = _get(data, 'resumeList');
        const resumeListMappedDates = _map(resumeList, resume => {
            return convertFirebaseTimestampsToDate(resume, ['updateDt']);
        });
        data = _fpSet('resumeList', resumeListMappedDates, data);

        setProfileData({ ...data });
    });
};

export const loadProfileByCustomName = async ({ userName, setData }) => {
    const db = getFirestore();

    let userId = null;
    const usersQuery = db.collection('users').where('userNameLower', '==', _toLower(userName)).limit(1);
    const usersSnapshot = await usersQuery.get();
    usersSnapshot.forEach(userDoc => {
        userId = userDoc.id;
    });

    if (userId) {
        const profileRef = db.collection('profiles').doc(userId);

        return profileRef.onSnapshot(docSnapshot => {
            let data = docSnapshot.data();

            const isPublic = _get(data, 'isPublic');
            const nameFields = _pick(data, ['firstName', 'middleName', 'lastName']);

            data = isPublic ? { ...convertFirebaseTimestampsToDate(data, ['createDt', 'updateDt']) } : { isPublic: false, ...nameFields };

            setData(data);
        });
    }
};

export const fetchProfilesByUserIdList = async ({ userIdList, setList }) => {
    const db = getFirestore();

    const profiles = [];
    await Promise.all(
        _map(userIdList, async userId => {
            const profileRef = db.collection('profiles').doc(userId);
            const profileDoc = await profileRef.get();
            if (profileDoc.exists) {
                profiles.push(mapProfileFromFirestore({ userId, dto: profileDoc.data() }));
            }
        }),
    );

    setList && setList(profiles);

    return profiles;
};

export const saveSamplePage = async ({
    userId,
    country,
    state,
    city,
    cityLocation,
    salaryRange,
    occupation,
    // setSnackbarMessage,
    // setSnackbarErrorMessage,
}) => {
    const db = getFirestore();

    const ref = db.collection('samplePages').doc(userId);

    try {
        // Update Profile document
        await db.runTransaction(async transaction => {
            // This code may get re-run multiple times if there are conflicts.
            const doc = await transaction.get(ref);

            if (!doc.exists) {
                throw new Error('samplePage document does not exist!');
            }

            const dto = {
                country: country || null,
                state: state || null,
                city: _get(city, 'name', null),
                cityLocation: cityLocation || null,
                salaryRange: !salaryRange || _isNaN(salaryRange) ? null : _toNumber(salaryRange),
                occupation: mapCreatableLovOptionsToValueList({ options: occupation }),
            };

            transaction.update(ref, {
                ...deleteEmptyFields(dto),
                updateDt: new Date(),
            });
        });

        // Add new LOV options (if any)
        // 'newLovOptions' updates will trigger a cloud function to insert new options to the corresponding LOV lists in 'app.lovs' (cloud function coming soon)
        try {
            const newLovOptionsDto = {};

            const newOccupationOptions = getNewLovOptions(occupation);
            if (newOccupationOptions.length > 0) {
                _set(newLovOptionsDto, 'newOccupationOptions', newOccupationOptions);
            }

            if (isNewLovOption(city)) {
                _set(newLovOptionsDto, 'newCityOption', _get(city, 'name') || 'Unknown City');
                _set(newLovOptionsDto, 'newCityOptionState', state || 'Unknown State');
                _set(newLovOptionsDto, 'newCityOptionCountry', country || 'Unknown Country');
            }

            if (!_isEmpty(newLovOptionsDto)) {
                db.collection('newLovOptions').add({
                    ...newLovOptionsDto,
                    createDt: new Date(),
                    createBy: userId,
                });
            }
        } catch (error) {
            console.error('Save profile about me new LOV options transaction failed: ', error);
            // setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
        }

        // console.log('Transaction successfully committed!');
        // setSnackbarMessage(SNACK_BAR_MESSAGE_SAVE); // Snackbar commented out for sample page
    } catch (error) {
        console.error('Save profile about me transaction failed: ', error);
        // setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED); // Snackbar commented out for sample page
    }
};

export const updateMyProfileReminderDts = async ({ userId, isShowWalkThrough, isShowFirstTimeShareTourStep, isShowMakePublicReminderAgain } = {}) => {
    const db = getFirestore();

    const now = new Date();
    const ref = db.collection('dashboards').doc(userId);

    try {
        // Update Dashboard document
        await db.runTransaction(async transaction => {
            // This code may get re-run multiple times if there are conflicts.
            const dto = {};
            if (isShowWalkThrough) {
                // user has seen the complete walk-through
                _set(dto, 'showMakeProfilePublicTourStepDt', now);
                _set(dto, 'showShareProfileTourStepDt', now);
            } else if (isShowMakePublicReminderAgain) {
                // user has seen the make-profile-public reminder
                _set(dto, 'showMakeProfilePublicTourStepDt', now);
            } else if (isShowFirstTimeShareTourStep) {
                // user has seen the share-profile reminder
                _set(dto, 'showMakeProfilePublicTourStepDt', now); // assuming he has a public profile already when we release the walk-through update
                _set(dto, 'showShareProfileTourStepDt', now);
            }

            transaction.set(
                ref,
                {
                    ...dto,
                    updateDt: new Date(),
                },
                { merge: true },
            );
        });
    } catch (error) {
        console.error('Save My Profile reminder timestamps transaction failed: ', error);
    }
};
